<template>
  <LoadingWrapper :state="status">
    <div class="flex flex-col gap-6 pb-4">
      <div v-for="section in data" :key="section.feedbackTopic.id">
        <h2 class="text-title-large mb-4 inline-flex items-center">
          <BaseIcon v-if="section.feedbackTopic.icon" size="22" class="mr-2">{{
            section.feedbackTopic.icon
          }}</BaseIcon>
          {{ section.feedbackTopic.title }}
        </h2>
        <EvaluationProfileAnalysis
          v-if="section.type == FeedbackTopicType.Evaluation"
          :skills="section.analysis.skills"
          :questions="section.analysis.questions"
          :scale="section.analysis.scale"
          :texts="section.analysis.texts"
          :subject="user"
          :topic-perspectives="perspectivesFromTopic(section.feedbackTopic)"
          :skill-visualization="section.feedbackTopic.skillVisualization ?? []"
          :show-blindspots="section.feedbackTopic.showBlindspots ?? false"
          :hide-empty-skills="true"
        />
        <PulseProfileAnalysis
          v-if="section.type == FeedbackTopicType.Pulse"
          :questions="section.analysis.questions"
          :texts="section.analysis.texts"
          :topic-perspectives="perspectivesFromTopic(section.feedbackTopic)"
        />
      </div>
    </div>
  </LoadingWrapper>
</template>
<script lang="ts" setup>
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { useSurveyAnalysis } from '../composables/use-survey-analysis'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import EvaluationProfileAnalysis from '@/core/components/analytics/EvaluationProfileAnalysis.vue'
  import { useUserStore } from '@/stores/user.store'
  import { FeedbackTopicType } from '@/core/models/feedback-topic.ts'
  import PulseProfileAnalysis from '@/core/components/analytics/PulseProfileAnalysis.vue'
  import { perspectivesFromTopic } from '@/core/models/perspective'

  const { data, status } = useSurveyAnalysis()
  const { user } = useUserStore()
</script>
